// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// import {config } from 'dotenv';
// config();

export const environment = {
  production: false,
  notchFrontendServiceUrl: "https://test.notchcx.io",
  chatServiceUrl: "https://chat-test.notchcx.io",
  commandCenterUrl: "https://commandcenter-test.notchcx.io",
  commsServiceUrl: "https://comms-test.notchcx.io",
  twitterServiceUrl: "https://twitter-test.notchcx.io",
  keysUrl: "https://keys-test.notchcx.io",
  filesServiceUrl: "https://files-test.notchcx.io",
  notificationsServiceUrl: "https://notifications-test.notchcx.io",
  salesClientServiceUrl: "https://sales-test.notchcx.io",
  targetServiceUrl: "https://target-test.notchcx.io",
  whatsAppBot: "https://whatsapp-test.notchcx.io",
  mailServiceUrl: "https://mail-test.notchcx.io",
  instagramServiceUrl: "https://instagram-test.notchcx.io",
  facebookServiceUrl: "https://facebook-test.notchcx.io",
  tiktokServiceUrl: "https://tiktok-test.notchcx.io",
  linkedinServiceUrl: "https://linkedin-test.notchcx.io",
  customFormUrl: "https://api-test.notchcx.io/forms",
  productsAndService: "https://atbstore.blob.core.windows.net/samples/sample-products.csv?sp=r&st=2026-09-15T12:49:10Z&se=2027-12-15T22:59:10Z&spr=https&sv=2026-02-06&sr=b&sig=wgo65uR4dCMqS6sGYZkh78%2B4cuyH00RjXtVTswnA9bQ%3D",
  templateAndSequenceUrl: "https://tempseq-test.notchcx.io",
  paystackKey: "pk_test_9355c1d0251eb11893439609e42dcacfad163f57",
  DownloadUrl: "https://sales-test.notchcx.io/samples",
  apiUrl: "https://api-test.notchcx.io",
  localUrl: "http://10.10.100.79:",
  localUrlJava: "http://10.10.100.79:",
  localUrlNode: "http://localhost:",
  socketUrl: "https://notch-chat-bot.herokuapp.com",
  emailDomain: "@app.notchcx.io",
  baseUrl: "https://test.notchcx.io",
  notchWebsite: "https://notchcx.io",
  notchAppURL: "https://test.notchcx.io",
  notchPDFConverter: "https://files.notchcx.io/attachments/pdf/conversion",
  fileUrl: "",
  emailAlternative: ",notanemailaddressatall.com",
  notchTenantInfo: { id: 16882, name: "ProTech" },
  whatsappAppConfig: {
    appId: "846490181757513",
    configId: "801861146264572"
  }
};

export const Office365OuthSettings = {
  appId: "6c63c897-fadd-494b-a31e-0e9482e7c731",
  authority: "https://login.microsoftonline.com/common/",
  redirectUri: "http://localhost:4200/clients/outlook-callback",
  scopes: ["offline_access", "Mail.ReadWrite", "Mail.Send", "User.Read"],
  validateAuthority: false,
};

export const PathfixConfig = {
  public_key: "46909325-A1AB-4CB8-87EB-BF8C5BC3E464",
};

export const GmailRedirectUri = `http://localhost:4200/clients/google-callback`;

export const FacebookSettings = {
  clientId: "3048240628766460",
  redirectUri: "https://test.notchcx.io/settings/ticket-inbound",
  scope: `pages_show_list pages_manage_metadata pages_messaging  pages_read_engagement pages_manage_engagement pages_read_user_content pages_manage_posts pages_manage_engagement pages_read_user_content pages_manage_posts   instagram_basic business_management instagram_manage_messages instagram_manage_comments instagram_content_publish instagram_manage_insights`,
};

export const LinkedInSettings = {
  clientId: "778zbkg8b6qbkt",
  redirectUri: "https://test.notchcx.io/settings/ticket-inbound",
  scope: `email profile r_organization_social rw_organization_admin r_basicprofile`,
};

export const GeoLocation = {
  uri: "https://api.ipgeolocation.io/ipgeo?apiKey=c657119c9af34dc4a6e4b8e8f059557e"
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
